import type { AssistantAttachment } from "../../../api/types/assistantTypes";
import { messagePayloadError } from "./attachmentLimits";

export interface PendingAttachment {
  key: string;
  file: File;
  attachment?: AssistantAttachment;
  error?: string;
}

export const getReadyAttachments = (attachments: PendingAttachment[]): AssistantAttachment[] =>
  attachments.flatMap((pending) => (pending.attachment ? [pending.attachment] : []));

export const canSendMessage = (prompt: string, attachments: PendingAttachment[]): boolean => {
  const readyAttachments = getReadyAttachments(attachments);
  const hasContent = prompt.trim() !== "" || readyAttachments.length > 0;
  return (
    hasContent && readyAttachments.length === attachments.length && messagePayloadError(readyAttachments) === undefined
  );
};
